<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4>{{'internal-facilities.feature-flags.usage-modal.title' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="main">
        <ng-container *ngIf="!apiFailed && !loading">
          <div class="row mb-3">
            <div class="col-sm">
              <label>
                {{ 'internal-facilities.feature-flags.usage-modal.current-usage' | translate }}
              </label>
              <div class="row__usage-progress d-flex align-items-center">
                <div class="vox-paragraph">{{flagOverview.total_enabled_companies}}</div>
                <div class="vox-progress-text progress flex-fill ml-2 mr-2">
                  <span class="vox-progress-text__text vox-progress-text__text_size-s">{{ flagOverview.enabled_percentage }}%</span>
                  <div class="vox-progress-text__bar vox-progress-text__bar_aquamarine" role="progressbar" [ngStyle]="{'width.%': flagOverview.enabled_percentage}"></div>
                </div>
                <div class="vox-paragraph">{{flagOverview.total_companies}}</div>
              </div>
            </div>
          </div>
          <div class="row mb-3 row__company-dropdown">
            <div class="form-group col-12">
              <label for="company"
                translate>internal-facilities.feature-flags.usage-modal.company-dropdown.label</label>
              <div class="d-flex align-items-start">
                <div class="vox-input-group_dense flex-fill mr-2">
                  <gdp-company-search [formControl]="companyControl"></gdp-company-search>
                  <div *ngIf="companyAlreadyAdded" class="vox-input-group vox-input-group_dense vox-input-group_invalid">
                    <div class="vox-input-group__message vox-text-bright-crimson" translate>internal-facilities.feature-flags.usage-modal.validation.already-selected</div>
                  </div>
                </div>
                <button type="button" (click)="addCompany()" [disabled]="!companyControl.value || companyAlreadyAdded" class="vox-btn vox-btn-secondary" translate>internal-facilities.feature-flags.usage-modal.button-enable</button>
              </div>
            </div>
          </div>
          <gdp-flags-company-table (onRemoveCompany)="removeCompany($event)" [companies]="flagOverview.enabled_companies"></gdp-flags-company-table>
          <div class="d-flex justify-content-end">
            <button [disabled]="!hasChanges || saveLoading" [ladda]="saveLoading" data-spinner-color="grey" data-style="zoom-in" type="button" class="vox-btn vox-btn-secondary" (click)="save()">{{ 'internal-facilities.feature-flags.usage-modal.save' | translate }}</button>
          </div>
        </ng-container>
        <ng-container *ngIf="apiFailed && !loading">
          <div class="vox-inline-message vox-inline-message_light-grey">
            <div>
              <i class="icon-small-alert"></i>
              {{'internal-facilities.feature-flags.errors.flag-overview-fetch-failed' | translate}}
            </div>
            <button type="button" class="vox-btn vox-btn-secondary" (click)="fetchFlagOverview()"
              translate>internal-facilities.feature-flags.buttons.retry</button>
          </div>
        </ng-container>
        <ng-container *ngIf="loading">
          <ngx-skeleton-loader *ngIf="loading" [theme]="{'margin-bottom': '10px', 'height': '40px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader *ngIf="loading" [theme]="{'margin-bottom': '10px', 'height': '40px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader *ngIf="loading" [theme]="{'margin-bottom': '10px', 'height': '200px'}"></ngx-skeleton-loader>
          <div class="d-flex justify-content-end">
            <ngx-skeleton-loader *ngIf="loading" [theme]="{'margin-bottom': 0, 'height': '56px', 'width': '95px'}"></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>